import { render } from "./PotentialScoreChart.vue?vue&type=template&id=728cb14e&scoped=true&lang=pug"
import script from "./PotentialScoreChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialScoreChart.vue?vue&type=script&setup=true&lang=js"

import "./PotentialScoreChart.vue?vue&type=style&index=0&id=728cb14e&lang=sass&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728cb14e"]])

export default __exports__